import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { FuaFormData } from 'components/Assessments/FuaAssessment/types/FuaFormData'
import { MedicalBackgroundQuestionnaireItem } from 'components/Assessments/FuaAssessment/sections/MedicalBackground/questionnaire'
import { SensoryFormField } from './formField'

/**
 * Sensory subsection adapter
 * Handles sensory status for all five senses plus system summary (6 fields)
 */
export class SensoryAdapter extends BaseSubsectionAdapter<FuaFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<FuaFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // All sensory status fields
    const statusEyes = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EYES
    )?.at(0)

    const statusEars = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EARS
    )?.at(0)

    const statusNose = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_NOSE
    )?.at(0)

    const statusTouch = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TOUCH
    )?.at(0)

    const statusTaste = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TASTE
    )?.at(0)

    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [SensoryFormField.SENSORY_SENSORY_STATUS_EYES]: statusEyes,
      [SensoryFormField.SENSORY_SENSORY_STATUS_EARS]: statusEars,
      [SensoryFormField.SENSORY_SENSORY_STATUS_NOSE]: statusNose,
      [SensoryFormField.SENSORY_SENSORY_STATUS_TOUCH]: statusTouch,
      [SensoryFormField.SENSORY_SENSORY_STATUS_TASTE]: statusTaste,
      [SensoryFormField.SENSORY_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    return [
      {
        linkId: MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EYES,
        value: this.getFormDataField(SensoryFormField.SENSORY_SENSORY_STATUS_EYES)
      },
      {
        linkId: MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EARS,
        value: this.getFormDataField(SensoryFormField.SENSORY_SENSORY_STATUS_EARS)
      },
      {
        linkId: MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_NOSE,
        value: this.getFormDataField(SensoryFormField.SENSORY_SENSORY_STATUS_NOSE)
      },
      {
        linkId: MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TOUCH,
        value: this.getFormDataField(SensoryFormField.SENSORY_SENSORY_STATUS_TOUCH)
      },
      {
        linkId: MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TASTE,
        value: this.getFormDataField(SensoryFormField.SENSORY_SENSORY_STATUS_TASTE)
      },
      {
        linkId: MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SYSTEM_SUMMARY,
        value: this.getFormDataField(SensoryFormField.SENSORY_SYSTEM_SUMMARY)
      }
    ]
  }
}
